<template>
  <div style="width: 100%; overflow-y: auto">
    <!--   <div class="headCon flex-row">
      <p>基本信息</p>
      <img @click="back" class="backIcon" src="@/assets/images/mobile/return.png" alt="" />
    </div>-->
    <el-header class="header">
      <div class="header-wrap">
        <img
          src="@/assets/images/mobile/return.png"
          class="header-img"
          @click="back"
        />
      </div>
      <p>基本信息</p>
    </el-header>
    <div class="mainContent">
      <div class="infoItem flex-row-between">
        <span>企业名称</span>
        <span>{{baseInfo.name}}</span>
      </div>
      <div class="infoItem flex-row-between">
        <span>统一社会信用代码</span>
        <span>{{baseInfo.shxydm}}</span>
      </div>
      <div class="infoItem flex-row-between">
        <span>企业邮箱</span>
        <span>{{baseInfo.qyyx}}</span>
      </div>
      <div class="infoItem flex-row-between">
        <div class="addressName">企业地址</div>
        <div id="address" ref="address">
          {{baseInfo.zbdz}}
        </div>
      </div>
      <div class="bottomCon">
        <p>简介</p>
        <div class="briefCon">
          {{baseInfo.qyjj}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  props: {},
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
  },
  data() {
    return {
      baseInfo:{},
    };
  },
  created() {
    this.getBaseInfo();
  },
  mounted() {},
  methods: {
    back() {
      this.$router.push("/userCenter");
    },
    getBaseInfo() {
      let url = "/dev-api/enterprise/baseInfo/getInfoByShxydm";
      let params = {
        shxydm: this.userInfo.tyshxydm,
      };
      this.$httpApi.get(url,params).then(res=>{
        this.baseInfo =res.data;
      }).catch(e=>{
        console.log(e);
      })
    },
  },
};
</script>

<style lang='scss' scoped>
.header {
  z-index: 100;
  width: 100%;
  height: 5.25rem !important;
  background-color: #36aa60;
  position: relative;
  .header-wrap {
    position: absolute;
    top: 0.625rem;
    left: 0.625rem;
    .header-img {
      width: 30px;
      height: 30px;
      margin-top: 1rem;
    }
  }
  p {
    height: 20px;
    text-align: center;
    color: #fff;
    font-size: 22px;
    line-height: 4;
    letter-spacing: 0.5rem;
  }
}

.mainContent {
  font-size: 1rem;
  color: #000;
  .infoItem {
    width: 100%;
    height: 5rem;
    border-bottom: 2px solid #e2e2e2;
    padding: 0 15px;
  }
  .addressName {
    width: 100px;
  }
  #address {
    min-width: 70px;
    text-align: justify;
  }
  .bottomCon {
    p {
      padding-left: 15px;
      margin: 10px 0;
    }
    .briefCon {
      width: 92%;
      min-height: 18.75rem;
      margin: 10px auto;
      border: 2px solid #e2e2e2;
      border-radius: 20px;
      padding: 20px;
    }
  }
}
</style>
